import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    this.addIubendaScript();
  }

  private addIubendaScript() {
    (function (w,d) {
      var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; 
      s.src="https://cdn.iubenda.com/iubenda.js"; 
      tag.parentNode.insertBefore(s,tag);
    })(window, document);
  
  }

}
